import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 9,
	viewBox: "0 0 14 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0.525024 2.50006L2.37502 0.550048L7.02502 5.20005L11.675 0.550049L13.5 2.50006L7.02502 8.90005L0.525024 2.50006Z",
		fill: "#1B2021"
	})]
});
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
